import React, {useEffect, useRef} from 'react';
import {Input} from 'antd';
import Cleave from 'cleave.js';

const CleaveInput = ({options, onChange, ...rest}) => {
    const inputRef = useRef(null);
    const cleaveRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            cleaveRef.current = new Cleave(inputRef.current.input, {
                ...options,
                onValueChanged: (e) => {
                    onChange?.({
                        target: {
                            value: e.target.value,
                            rawValue: e.target.rawValue,
                        },
                    });
                },
            });
        }

        return () => {
            cleaveRef.current?.destroy?.();
        };
    }, []);

    return (
        <Input
            {...rest}
            ref={inputRef}
            onChange={(e) => {
                onChange?.(e)
            }}
        />
    );
};

export default CleaveInput;
